<template>
    <div class="animated fadeIn">
        <b-card >
            <template v-slot:header>
                <h5>Edit Gadai Kendaraan</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="detail-data-wrapper mb-4">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label"><strong>No. Faktur</strong></b-col>
                        <b-col v-if="dataKend.noFaktur != null"><strong>{{ dataKend.noFaktur }}</strong></b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Status Gadai</b-col>
                        <b-col v-if="dataKend.statusGadai != null">{{ dataKend.statusGadai }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA ANGGOTA</h6>
                    <div class="detail-data-wrapper mb-4">
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                            <b-col v-if="dataKend.anggota.noAnggota != null"><strong>{{ dataKend.anggota.noAnggota }}</strong></b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Jenis Identitas</b-col>
                            <b-col v-if="dataKend.anggota.jenisIdentitas != null">{{ dataKend.anggota.jenisIdentitas }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. Identitas</b-col>
                            <b-col v-if="dataKend.anggota.noIdentitas != null">{{ dataKend.anggota.noIdentitas }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Nama</b-col>
                            <b-col v-if="dataKend.anggota.namaAnggota != null">{{ dataKend.anggota.namaAnggota }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Alamat</b-col>
                            <b-col v-if="dataKend.anggota.alamat != null">{{ dataKend.anggota.alamat }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                            <b-col v-if="dataKend.anggota.noHp != null">{{ dataKend.anggota.noHp }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. Rumah</b-col>
                            <b-col v-if="dataKend.anggota.noRumah != null">{{ dataKend.anggota.noRumah }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                    </div>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA KENDARAAN</h6>
                    <b-form-group label="Tipe Pinjaman">
                        <div class="d-flex">
                            <b-form-radio class="mr-3" v-model="dataKend.barang.kendaraan.withKendaraan" name="gadaiTipePinjaman" value="true">Kendaraan + BPKB</b-form-radio>
                            <b-form-radio v-model="dataKend.barang.kendaraan.withKendaraan" value="false">BPKB Saja</b-form-radio>
                        </div>
                    </b-form-group>
                    <b-form-group label="Jenis Kendaraan">
                        <b-form-select v-model="dataKend.barang.jenis" name="gadaiJenisKendaraan" required>
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                <b-form-select-option v-for="(item, idx) in optKendaraanJenis" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                    {{ item.name }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Merk Kendaraan">
                        <b-form-select v-model="dataKend.barang.merk" name="gadaiMerkKendaraan" required :disabled="optKendaraanMerk.length == 0">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                <b-form-select-option v-for="(item, idx) in optKendaraanMerk" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                    {{ item.name }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Tipe Kendaraan">
                        <b-form-select v-model="dataKend.barang.tipe" name="gadaiTipeKendaraan" required :disabled="optKendaraanTipe.length == 0">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                <b-form-select-option v-for="(item, idx) in optKendaraanTipe" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                    {{ item.name }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Tahun">
                        <b-form-select v-model="input.tahunGadai" name="gadaiTahunKendaraan" required :disabled="optKendaraanTahun.length == 0">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                <b-form-select-option v-for="(item, idx) in optKendaraanTahun" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                    {{ item.name }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Kondisi / Grade Kendaraan">
                        <b-form-select v-model="input.dataKondisi" name="gadaiKondisiKendaraan" required :options="optKendaraanKondisi" :disabled="optKendaraanKondisi.length == 0">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Warna Kendaraan">
                        <b-form-select v-model="dataKend.barang.warna.id" name="gadaiWarnaKendaraan" required :options="optKendaraanWarna" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Status Kendaraan">
                        <b-form-input v-model="dataKend.barang.kendaraan.status" name="gadaiStatusKendaraan" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="No. Polisi">
                        <b-form-input v-model="dataKend.barang.kendaraan.noPolisi" name="gadaiNoPolisi" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Kelengkapan Kendaraan">
                        <div v-if="optKelengkapanKendaraan.length == 0" class="text-muted">
                            Tidak ada kelengkapan dari jenis kendaraan yang dipilih.
                        </div>
                        <b-form-checkbox-group class="checkbox-group" v-else v-model="input.kelengkapanGadai" name="gadaiKelengkapanKendaraan">
                            <b-form-checkbox v-for="item in optKelengkapanKendaraan" v-bind:key="item.id" :value="{ id: item.id, name: item.name }">
                                {{ item.name }}
                            </b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-form-group>
                    <b-form-group label="Spesifikasi Kendaraan (Jenis)">
						<b-row>
							<b-col md="6">
								<span class="text-muted">Penambahan</span>
								<div v-if="optKendaraanSpekJenis.penambahan.length == 0" class="text-muted mb-2">
									Tidak ada penambahan spesifikasi dari jenis kendaraan yang dipilih.
								</div>
								<b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiJenis" name="gadaiPenambahanSpekJenisBarangKend">
									<b-form-checkbox class="d-block" v-for="item in optKendaraanSpekJenis.penambahan" v-bind:key="item.id" :value="item.id">
										{{ item.name }}
									</b-form-checkbox>
								</b-form-checkbox-group>
							</b-col>
							<b-col md="6">
								<span class="text-muted">Pengurangan</span>
								<div v-if="optKendaraanSpekJenis.pengurangan.length == 0" class="text-muted mb-2">
									Tidak ada pengurangan spesifikasi dari jenis kendaraan yang dipilih.
								</div>
								<b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiJenis" name="gadaiPenguranganSpekJenisBarangKend">
									<b-form-checkbox class="d-block" v-for="item in optKendaraanSpekJenis.pengurangan" v-bind:key="item.id" :value="item.id">
										{{ item.name }}
									</b-form-checkbox>
								</b-form-checkbox-group>
							</b-col>
						</b-row>
                    </b-form-group>
                    <b-form-group label="Spesifikasi Kendaraan (Merk)">
						<b-row>
							<b-col md="6">
								<span class="text-muted">Penambahan</span>
								<div v-if="optKendaraanSpekMerk.penambahan.length == 0" class="text-muted mb-2">
									Tidak ada penambahan spesifikasi dari merk kendaraan yang dipilih.
								</div>
								<b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiMerk" name="gadaiPenambahanSpekMerkBarangKend">
									<b-form-checkbox class="d-block" v-for="item in optKendaraanSpekMerk.penambahan" v-bind:key="item.id" :value="item.id">
										{{ item.name }}
									</b-form-checkbox>
								</b-form-checkbox-group>
							</b-col>
							<b-col md="6">
								<span class="text-muted">Pengurangan</span>
								<div v-if="optKendaraanSpekMerk.pengurangan.length == 0" class="text-muted mb-2">
									Tidak ada pengurangan spesifikasi dari merk kendaraan yang dipilih.
								</div>
								<b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiMerk" name="gadaiPenguranganSpekMerkBarangKend">
									<b-form-checkbox class="d-block" v-for="item in optKendaraanSpekMerk.pengurangan" v-bind:key="item.id" :value="item.id">
										{{ item.name }}
									</b-form-checkbox>
								</b-form-checkbox-group>
							</b-col>
						</b-row>
                    </b-form-group>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA STNK</h6>
                    <b-form-group label="STNK Atas Nama">
                        <b-form-input v-model="dataKend.barang.kendaraan.namaSTNK" name="gadaiNamaStnk" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Alamat STNK">
                        <b-form-input v-model="dataKend.barang.kendaraan.alamatSTNK" name="gadaiAlamatStnk" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Masa berlaku pajak STNK">
                        <b-form-input v-model="dataKend.barang.kendaraan.pajakSTNK" name="gadaiMasaBerlakuStnk" type="date" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA BPKB</h6>
                    <b-form-group label="No. BPKB">
                        <b-form-input v-model="dataKend.barang.kendaraan.noBPKB" name="gadaiNoBpkb" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="BPKB Atas Nama">
                        <b-form-input v-model="dataKend.barang.kendaraan.namaBPKB" name="gadaiNamaBpkb" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="No. Mesin">
                        <b-form-input v-model="dataKend.barang.kendaraan.noMesin" name="gadaiNoMesin" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="No. Rangka">
                        <b-form-input v-model="dataKend.barang.kendaraan.noRangka" name="gadaiNoRangka" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PENDUKUNG</h6>
                    <div>
                        <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukung" name="fotoPendukungAddBtn"><i class="fa fa-plus mr-2"></i>Foto Pendukung</b-button>
                        <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal 6 Foto</div>
                        <FotoPendukung 
                            v-for="item in input.foto" 
                            v-bind:key="item.index" 
                            :fotoPendukung="item" 
                            :length="input.foto.length" 
                            :minLength="minLengthFotoPendukung"
                            @remove="removeFotoPendukung"
                            @showModalCam="openModalCam" 
                            @showModalPreview="openModalPreview"
                        />
                    </div>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">ALASAN PERUBAHAN</h6>
                    <b-form-group label="Keterangan/ Alasan Perubahan">
                        <b-form-textarea
                            id="textarea"
                            v-model="input.alasanPerubahan" name="alasanPerubahan"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="gadaiUpdateBtn" variant="primary">Update</b-button>
                </div>
            </b-form>
            <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Gadai Kendaraan" alertMessage="Perubahan ini akan diperiksa dan disetujui oleh KCS terlebih dahulu sebelum data gadai diubah" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah gadai kendaraan ini?" @submit="onSubmit" />
            <ModalWebCam @photoTaken="setResult"  />
            <ModalPreview :fotoPreview="activeFotoPreview" />
            <b-modal id="modal-confirm-lanjutGadai" title="Confirm Info Gadai" hide-header-close no-close-on-esc no-close-on-backdrop>
                <p class="mb-0">Mohon informasikan IG terlebih dahulu mengenai data mobil yang akan digadaikan. Hanya lanjutkan apabila pihak IG sudah memberikan perintah untuk melanjutkan input gadai.</p>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                        Lanjutkan Gadai
                    </b-button>
                </template>
            </b-modal>
        </b-card>
    </div>
</template>

<script>
import FotoPendukung from '../../../components/webcam/FotoPendukung'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'

export default {
    name: 'gadai-kendaraan',
    components: {
        FotoPendukung,
        ModalWebCam,
        ModalPreview
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isLoading: true,
            
            dataKend: {
                anggota: [],
                barang: {
                    foto: [],
                    jenis: [],
                    merk: [],
                    tipe: [],
                    gradeKondisi: [],
                    warna: [],
                    kendaraan: {},
                },
            },
            input:{
                foto: [],
                kelengkapanGadai: [],
                spesifikasiJenis:[],
                spesifikasiMerk:[],
                alasanPerubahan: "",
                tahunGadai: null,
                dataKondisi: null
            },

            indexFotoPendukung: 0,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 0,
            activeFotoPreview: "",

            optKendaraanJenis: [],
            optKendaraanMerk: [],
            optKendaraanTipe: [],
            optKendaraanTahun: [],
            optKendaraanKondisi: [],
            optKendaraanSpekJenis: {
				penambahan : [],
				pengurangan : []
			},
            optKendaraanSpekMerk: {
				penambahan : [],
				pengurangan : []
			},
            optKelengkapanKendaraan: [],
            optKendaraanWarna: [],
        }
    }, 
    watch: {
        'dataKend.barang.jenis': function(newVal) {
            
            if(this.isLoading != true){
                this.optKendaraanMerk = []
                this.dataKend.barang.merk = null

                this.optKelengkapanKendaraan = []
                this.input.kelengkapanGadai = []

                this.optKendaraanSpekJenis = {
					penambahan : [],
					pengurangan : []
				}
                this.input.spesifikasiJenis =[]

                if(newVal == null) { return }

                if(newVal.name == 'Mobil'){
                    this.$bvModal.show("modal-confirm-lanjutGadai")
                }

                // Lookup Merk
                this.$axios.get(`barang-merk/jenis/${newVal.id}`).then(response => {
                    this.optKendaraanMerk = response.data
                })

                // Lookup Kelengkapan Kendaraan
                this.$axios.get(`barang-jenis/kelengkapan?jenisId=${newVal.id}`).then(response => {
                    this.optKelengkapanKendaraan = response.data
                })

                // Lookup Spek Jenis
                this.$axios.get(`barang-jenis/spesifikasi?jenisId=${newVal.id}`).then(response => {
                    this.optKendaraanSpekJenis = response.data
                })
            }

        },

        'dataKend.barang.merk': function(newVal) {

            if(this.isLoading != true){
                this.optKendaraanTipe = []
                this.dataKend.barang.tipe = null
                
                this.optKendaraanSpekMerk = {
					penambahan : [],
					pengurangan : []
				}
                this.input.spesifikasiMerk = []

                if(newVal == null) { return }

                // Lookup Tipe
                this.$axios.get(`barang-tipe/merk/${newVal.id}`).then(response => {
                    this.optKendaraanTipe = response.data
                })

                // Lookup Spek Merk
                this.$axios.get(`barang-merk/spesifikasi?merkId=${newVal.id}`).then(response => {
                    this.optKendaraanSpekMerk = response.data
                })
            }

        },

        'dataKend.barang.tipe': function(newVal) {

            if(this.isLoading != true){
                this.optKendaraanTahun = []
                this.input.tahunGadai = null

                this.optKendaraanKondisi = []
                this.input.dataKondisi = null

                if(newVal == null) { return }

                // Lookup Tahun
                this.$axios.get(`barang-tipe/tahun/${newVal.id}`).then(response => {
                    this.optKendaraanTahun = response.data
                })

                // Lookup Kondisi
                this.$axios.get(`barang-tipe/kondisi/${newVal.id}`).then(response => {

                    let responseKondisi = response.data
                    for (let y=0; y< responseKondisi.length; y++){
                        let dataKondisi = {}
                        dataKondisi.value = responseKondisi[y].id
                        dataKondisi.text = responseKondisi[y].name.substring(4)
                        this.optKendaraanKondisi.push(dataKondisi)
                    }

                })
            }

        },

    },
    methods: {

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getJenisKendaraan = this.$axios.get("barang-jenis/kendaraan").then(response => {
                this.optKendaraanJenis = response.data
            })

            let getWarnaKend = this.$axios.get("gadai/warna").then(response => {
                this.optKendaraanWarna = response.data
            })

            let getEditKendaraan = this.$axios.get(`gadai/daftar-gadai/${this.id}/edit`).then(response => {
                this.dataKend= response.data
                console.log(response.data)
                //----------------- Inisialisasi Data Foto -----------------
                for (var x of this.dataKend.foto) {
                    this.input.foto.push({
                        index: this.indexFotoPendukung, 
                        id: x.id, 
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: this.$baseFilePath+x.name,
                        urlFotoBarangPendukung: x.name,
                    })
                    this.indexFotoPendukung++
                }

                if(this.dataKend.barang.jenis.id != null){
                    this.$axios.get(`barang-jenis/kelengkapan?jenisId=${this.dataKend.barang.jenis.id}`).then(response => {
                        this.optKelengkapanKendaraan = response.data
                        //----------------- Inisialisasi Kelengkapn -----------------
                        for (var x of this.dataKend.barang.kelengkapan) {
                            let idx = this.optKelengkapanKendaraan.findIndex(item => item.name == x.trim());
                            if(idx != -1) this.input.kelengkapanGadai.push(this.optKelengkapanKendaraan[idx])
                        }
                    })
                    
                    this.$axios.get(`barang-jenis/spesifikasi?jenisId=${this.dataKend.barang.jenis.id}`).then(response => {
                        this.optKendaraanSpekJenis = response.data
                        for (var x of this.dataKend.barang.spesifikasi) {
                            //----------------- Inisialisasi Spesifikasi Jenis -----------------
                            
                            let idxSpekJenisPenambahan = this.optKendaraanSpekJenis.penambahan.findIndex(item => item.id == x.id);
                            if(idxSpekJenisPenambahan >= 0){
                                this.input.spesifikasiJenis.push(this.optKendaraanSpekJenis.penambahan[idxSpekJenisPenambahan].id)
							}
							let idxSpekJenisPengurangan = this.optKendaraanSpekJenis.pengurangan.findIndex(item => item.id == x.id);
                            if(idxSpekJenisPengurangan >= 0){
                                this.input.spesifikasiJenis.push(this.optKendaraanSpekJenis.pengurangan[idxSpekJenisPengurangan].id)
                            }
                        }
                    })
                    this.$axios.get(`barang-merk/jenis/${this.dataKend.barang.jenis.id}`).then(response => {
                        this.optKendaraanMerk = response.data
                        if(this.dataKend.barang.merk.id != null){
                            this.$axios.get(`barang-merk/spesifikasi?merkId=${this.dataKend.barang.merk.id}`).then(response => {
                                this.optKendaraanSpekMerk = response.data
                                for (var x of this.dataKend.barang.spesifikasi) {
                                    //----------------- Inisialisasi Spesifikasi Merk -----------------
                                    let idxSpekMerkPenambahan = this.optKendaraanSpekMerk.penambahan.findIndex(item => item.id == x.id);
                                    if(idxSpekMerkPenambahan >= 0){
                                        this.input.spesifikasiMerk.push(this.optKendaraanSpekMerk.penambahan[idxSpekMerkPenambahan].id)
									}
									let idxSpekMerkPengurangan = this.optKendaraanSpekMerk.pengurangan.findIndex(item => item.id == x.id);
                                    if(idxSpekMerkPengurangan >= 0){
                                        this.input.spesifikasiMerk.push(this.optKendaraanSpekMerk.pengurangan[idxSpekMerkPengurangan].id)
                                    }
                                }
                            })
                            this.$axios.get(`barang-tipe/merk/${this.dataKend.barang.merk.id}`).then(response => {
                                this.optKendaraanTipe = response.data
                                if(this.dataKend.barang.tipe.id !=null){
                                    this.$axios.get(`barang-tipe/tahun/${this.dataKend.barang.tipe.id}`).then(response => {
                                        this.optKendaraanTahun = response.data
                                        let idxTahunGadai = this.optKendaraanTahun.findIndex(item=>item.name == this.dataKend.barang.tahun);
                                        this.input.tahunGadai=this.optKendaraanTahun[idxTahunGadai]
                                    })
                                    this.$axios.get(`barang-tipe/kondisi/${this.dataKend.barang.tipe.id}`).then(response => {
                                        
                                        let responseKondisi = response.data
                                        for (let y=0; y< responseKondisi.length; y++){
                                            let dataKondisi = {}
                                            dataKondisi.value = responseKondisi[y].id
                                            dataKondisi.text = responseKondisi[y].name.substring(4)
                                            this.optKendaraanKondisi.push(dataKondisi)
                                        }
                                        console.log(response.data)

                                        let dataOptKondisi = JSON.parse(JSON.stringify(response.data))
                                        let dataGradeKondisi = dataOptKondisi.filter(item=> item.name == this.dataKend.barang.gradeKondisi.name)
                                        if(dataGradeKondisi.length != 0){
                                            this.input.dataKondisi = dataGradeKondisi[0].id
                                        }else{
                                            this.input.dataKondisi = null
                                        }
                                        console.log(this.input.dataKondisi)
                                    })
                                }
                            })
                        }
                    })
                }

            })

            Promise.all([getJenisKendaraan, getWarnaKend, getEditKendaraan]).then(() => {
                this.initStatus = 1
                this.isLoading = false
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            if(this.dataKend.barang.jenis.name.startsWith('Lainnya')){
                this.$helper.toastErr(this, "Jenis kendaraan tidak boleh lainnya")
            }else if(this.dataKend.barang.jenis.id == null){
                this.$helper.toastErr(this, "Mohon isi jenis terlebih dahulu")
            }else if(this.dataKend.barang.merk.id == null){
                this.$helper.toastErr(this, "Mohon isi merk terlebih dahulu")
            }else if(this.dataKend.barang.tipe.id == null){
                this.$helper.toastErr(this, "Mohon isi tipe terlebih dahulu")
            }else{
                let payload = new FormData()
                this.id = this.$route.params.id

                //----------------- Append Data Gadai -----------------

                payload.append("id", this.id)
                payload.append("jenisPinjamanId", 2) // MARK HARDCODE
                payload.append("jenisBarangId", this.dataKend.barang.jenis.id)
                payload.append("merkId", this.dataKend.barang.merk.id)
                payload.append("tipeId", this.dataKend.barang.tipe.id)
                payload.append("kondisiId ", this.input.dataKondisi)
                payload.append("warnaId ", this.dataKend.barang.warna.id)
                payload.append("statusKendaraan", this.dataKend.barang.kendaraan.status)
                payload.append("stnkAtasNama", this.dataKend.barang.kendaraan.namaSTNK)
                payload.append("stnkAlamat", this.dataKend.barang.kendaraan.alamatSTNK)
                payload.append("stnkMasaBerlakuPajak", this.dataKend.barang.kendaraan.pajakSTNK)
                payload.append("noBpkb", this.dataKend.barang.kendaraan.noBPKB)
                payload.append("bpkbAtasNama", this.dataKend.barang.kendaraan.namaBPKB)
                payload.append("noMesin", this.dataKend.barang.kendaraan.noMesin)
                payload.append("noRangka", this.dataKend.barang.kendaraan.noRangka)
                payload.append("noPolisi", this.dataKend.barang.kendaraan.noPolisi)
                payload.append("isBpkb", !(this.dataKend.barang.kendaraan.withKendaraan))
                // payload.append("keterangan", this.dataKend.barang.keterangan)
                payload.append("keteranganRevisi ", this.input.alasanPerubahan)
                
                if(this.$helper.isNotNullAndNotEmpty(this.input.tahunGadai)) {
                    payload.append("tahunId", this.input.tahunGadai.id)
                }

                // Append all checked spesifikasi
                for(let spek of this.input.spesifikasiJenis) {
                    payload.append("spesifikasiId", spek)
                }

                for(let spek of this.input.spesifikasiMerk) {
                    payload.append("spesifikasiId", spek)
                }

                // Kelengkapan
                if(this.input.kelengkapanGadai.length != 0) {

                    this.input.kelengkapanGadai.forEach(item => {
                        payload.append("kelengkapan", item.name)
                    })

                }

                // Upload photo only if on final step
                let jsonFoto = []
                this.input.foto.forEach(function(entry) {
                    jsonFoto.push(entry.activeFotoPendukungBase64)  
                })
                payload.append("foto", JSON.stringify(jsonFoto))
                this.$helper.printPayload(payload)
                //----------------- Submit Semua Data -----------------

                this.isSubmitting = true

                this.$axios.post(`gadai-crud/edit/${this.id}/kendaraan`, payload, { timeout: 300000 }).then(response => {

                    if(response.data.name == 'REFRESH_KONDISI'){
                        this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                        this.input.dataKondisi = null
                        this.optKendaraanKondisi = []
                        this.$axios.get(`barang-tipe/kondisi/${this.dataKend.barang.tipe.id}`).then(response => {

                            let responseKondisi = response.data
                            for (let y=0; y< responseKondisi.length; y++){
                                let dataKondisi = {}
                                dataKondisi.value = responseKondisi[y].id
                                dataKondisi.text = responseKondisi[y].name.substring(4)
                                this.optKendaraanKondisi.push(dataKondisi)
                            }

                        })
                    }else{
                        this.initStatus = 1
                        this.$helper.setFlash(`Perubahan gadai berhasil diajukan!`)
                        if(this.$route.path.includes("inquiry-faktur")){
                            let path = this.$route.path.split('/')
                            path.pop()
                            path.pop()
                            path = path.join("/")
                            this.$router.push({ path })
                        }else{
                            let path = this.$route.path.split('/')
                            path.pop()
                            path = path.join("/")
                            this.$router.push({ path })
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
            }
        },

        //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        addFotoPendukung() {
            if(this.input.foto.length < 6){
                this.input.foto.unshift({ 
                    index: this.indexFotoPendukung, 
                    id: 0, 
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null,
                    urlFotoBarangPendukung: null
                })
                this.indexFotoPendukung++;
            }else{
                this.fotoPendukungError = true;
            }
        },

        removeFotoPendukung(index) {
            this.input.foto = this.input.foto.filter(item => item.index != index)
            this.fotoPendukungError = false;
        },

        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            this.$bvModal.show("modal-confirm-edit")
        },
        
        openModalCam(index){
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("modal-ambil-foto")
        },

        openModalPreview(index){
            this.activeFotoPreviewIndex = index
            let idx = this.input.foto.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.input.foto[idx].activeFotoPendukungBase64
            this.$bvModal.show("modal-preview-foto")
        },

        async setResult(result){
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            let idx = this.input.foto.findIndex(item => item.index == this.activeFotoPendukungIndex);
            this.input.foto[idx].fotoBarangPendukungBase64 = newResult
            this.input.foto[idx].activeFotoPendukungBase64 = newResult
        },
    },
    created(){
        this.init()
    }
}
</script>
